import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import {
  switchAssignementStatus,
  switchSpreadsheetItemStatus,
} from "service/api";
import img_check from "../../../assets/img/check.svg";

const statuses = {
  user_filling: { key: "user_filling", name: "Черновик", color: "#585757" },
  manager_reviewing: { key: "manager_reviewing", name: "На рассмотрении", color: "#1570EF" },
  not_reviewing: { key: "not_reviewing", name: "Без рассмотрения", color: "gray" },
  user_fixing: { key: "user_fixing", name: "На доработке", color: "#F98600" },
  completed: { key: "completed", name: "Успешно завершен", color: "#4FBC4D" },
  rejected: { key: "rejected", name: "Отклонен", color: "#E92C2C" },
};

export const OrderStatusBadge = ({
  applicationId,
  assignmentId,
  status_name,
  withSwitch,
}: {
  assignmentId?: number;
  applicationId?: string;
  status_name: string;
  withSwitch?: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };
  const getSwitcher = () => {
    if (applicationId) {
      return switchSpreadsheetItemStatus;
    } else if (assignmentId) {
      return switchAssignementStatus;
    }
    return (t: any) => Promise.resolve(t);
  };

  if (!statuses[status_name]) return null;

  return (
    <Box>
      <Button
        sx={{
          backgroundColor: "#F2F4F7",
          p: "4px 12px 4px 10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          height: "fit-content",
          width: "fit-content",
          borderRadius: "16px",
          cursor: withSwitch ? "pointer" : "default",
        }}
        onClick={handleClick}
        id={`status-button-${applicationId}`}
        aria-controls={anchorEl ? `status-menu-${applicationId}` : undefined}
        aria-haspopup="true"
        aria-expanded={anchorEl ? "true" : undefined}
      >
        <Box
          sx={{
            display: "block",
            width: "6px",
            height: "6px",
            backgroundColor: statuses[status_name].color ?? "#000",
            borderRadius: "50%",
            mr: "7px",
          }}
        />
        <Typography
          fontSize={"14px"}
          lineHeight={"20px"}
          color={"#101828"}
          whiteSpace={"nowrap"}
        >
          {statuses[status_name].name ?? ""}
        </Typography>
      </Button>
      {withSwitch &&
        OrderStatusBadgeMenu({
          id: (applicationId || assignmentId) ?? "",
          status_name,
          anchorEl,
          setAnchorEl,
          switcher: getSwitcher(),
        })}
    </Box>
  );
};

export const OrderStatusBadgeMenu = ({
  id,
  status_name,
  anchorEl,
  setAnchorEl,
  switcher,
}: {
  id: any;
  status_name: string;
  anchorEl: any;
  setAnchorEl: any;
  switcher: (props: { id: any; statusName: string }) => Promise<any>;
}) => {
  const [loading, setLoading] = useState(false);

  const switchStatus = async (status_name) => {
    try {
      const res = await switcher({
        id: id,
        statusName: status_name,
      });
      if (res?.err) {
        alert(res);
        return;
      }
      window.location.reload();
    } catch (error) {
      alert(error);
    }
  };

  return (
    <Menu
      id={`status-menu-${id}`}
      sx={{
        mt: "-28px",
        // border: "1px solid #EAECF0",
        borderRadius: "8px",
        boxShadow:
          "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
        overflow: "hidden",
      }}
      MenuListProps={{
        sx: {
          p: "4px 6px",
        },
      }}
      anchorEl={anchorEl}
      open={anchorEl ? true : false}
      onClose={() => {
        setAnchorEl(null);
      }}
    >
      {Object.values(statuses).map((el) => {
        return (
          <MenuItem
            onClick={async () => {
              setLoading(true);
              await switchStatus(el.key);
              setAnchorEl(null);
              setLoading(false);
            }}
            sx={{ borderRadius: "6px", my: "2px", minWidth: "238px" }}
            disabled={loading}
            key={`status-${el.name}`}
          >
            <Box
              sx={{
                display: "block",
                width: "6px",
                height: "6px",
                backgroundColor: el.color,
                borderRadius: "50%",
                mr: "7px",
              }}
            ></Box>
            <Typography
              fontSize={"14px"}
              lineHeight={"20px"}
              whiteSpace={"nowrap"}
            >
              {el.name}
            </Typography>
            {el.name == statuses[status_name].name ? (
              <Box
                component={"img"}
                width={"20px"}
                src={img_check}
                sx={{ ml: "auto" }}
              />
            ) : null}
          </MenuItem>
        );
      })}
    </Menu>
  );
};
